var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" Reading List ")]),_vm._l((_vm.$store.state.eyeswanted),function(eyeswanted){return _c('UpdatePreview',{attrs:{"update":eyeswanted.update,"openUpdate":_vm.openUpdate}})}),(Object.keys(_vm.$store.state.eyeswanted).length===0)?_c('article',[_c('p',[_vm._v(" No eyes wanted updates. ")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }